import { Store } from 'pullstate';
import exampleResponse from '../components/Report/exampleResponse.json';

export const ReportsStore = new Store({
    reportData: null,
    currentStep: 1,
    emailSignIn: false,
    reports: [],
});
